"use strict";
"use client";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appsignal = void 0;
const javascript_1 = __importDefault(require("@appsignal/javascript"));
const plugin_breadcrumbs_network_1 = require("@appsignal/plugin-breadcrumbs-network");
const plugin_window_events_1 = require("@appsignal/plugin-window-events");
const APPSIGNAL_FRONTEND_KEY = process.env.NEXT_PUBLIC_APPSIGNAL_FRONTEND_KEY;
exports.appsignal = (() => {
    if (typeof window === "undefined")
        return null;
    if (!APPSIGNAL_FRONTEND_KEY)
        return null;
    const revision = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA?.trim() || "development";
    const instance = new javascript_1.default({
        key: APPSIGNAL_FRONTEND_KEY,
        namespace: "frontend",
        revision,
    });
    instance.use((0, plugin_window_events_1.plugin)());
    instance.use((0, plugin_breadcrumbs_network_1.plugin)());
    return instance;
})();
